/**
 * Created by Jie Gao on 2018-11-12.
 */
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {TimelineLite} from "gsap";
import {StarStruckParsedGameData} from "../../server/data/StarStruckParsedGameData";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {StarStruckReelAreaEvents} from "../../reel/events/StarStruckReelAreaEvents";
import {StarStruckGameModuleConfig} from "../../StarStruckGameModuleConfig";

export class BonusSymbolLanding extends ReelStopPresentationController {
    private _starWin:boolean;
    private _isSlowMotionStopping:boolean = false;
    private _gameMode:string;
    private _bonusFeatureTriggered:boolean;
    private _bounceUpwards:boolean = false;
    private _bonusWinBounce:number = -1;
    private _bounceStartPos:number = -1;

    constructor(index:number) {
        super(index, "BonusSymbolLanding");
    }

    protected parseFeatureGameData(data:StarStruckParsedGameData):void {
        this._isSlowMotionStopping = false;
        this._starWin = data.bonusWin;
        this._gameMode = data.mode;
        this._bonusFeatureTriggered = data.bonusFeatureTriggered;
        this._bonusWinBounce = (data.reels[1][2] === "B") ? (1 - Math.random() * 2) : -1;
        this._bounceUpwards = (data.reels[1][3] === "B" || (this._bonusWinBounce > 0));
        this._bounceStartPos = data.reels[1].indexOf("B") - 1;
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_STOP_SPIN, (event:GameEvent) => this.onStopSpin(event.params[0]));
        EventHandler.addEventListener(this, StarStruckReelAreaEvents.SLOW_MOTION_STOPPING, (event:GameEvent) => this.onSlowMotionStopping());
    }

    private onStopSpin(stopData:{ quickStop:boolean, fastSpin:boolean }):void {
        if(this._bonusFeatureTriggered && this._gameMode === GameMode.NORMAL && !this._isSlowMotionStopping) {
            EventHandler.dispatchEvent(new GameEvent(StarStruckReelAreaEvents.LIFT_REEL, {
                reelId : 1,
                bounceStartPos : this._bounceStartPos
            }));
        }
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(!this.tryPlayBouncePresentation(data)) {
            this.dispatchCompleteEvent(data.reelId);
        }
    }

    private tryPlayBouncePresentation(data:IReelStoppedData):boolean {
        if(data.reelId != 1 || !this._bonusFeatureTriggered) {
            return false;
        }

        const timeline:TimelineLite = new TimelineLite({paused : true});
        timeline.add(() => {
            EventHandler.dispatchEvent(new GameEvent(StarStruckReelAreaEvents.SLOW_MOTION_STOP, {
                reelId : 1,
                startPos : this._bounceStartPos,
                bounceUpwards : this._bounceUpwards
            }));
            StarStruckGameModuleConfig.hotZone.playHotZoneWinStar();
            StarStruckGameModuleConfig.nearwinBackground.hide(1);
        });

        timeline.add(() => {this.dispatchCompleteEvent(data.reelId);}, 5.4);
        timeline.play(0);

        return true;
    }

    private onSlowMotionStopping():void {
        this._isSlowMotionStopping = true;
    }

    public playReelBouncingSound(data:IReelStoppedData):boolean {
        return ((data.reelId === 1) ? (this._bonusFeatureTriggered) : false);
    }
}